export default __webpack_public_path__ + "static/media/ill-leave-holidays.3e62ee2d.svg";